/**
 * BLOCK: FAQ
 */
import classnames from 'classnames';
import React, { Suspense, useLayoutEffect } from 'react';
import lazyLoader from '@Controls/lazy-loader';
import { InnerBlocks } from '@wordpress/block-editor';
import styles from './editor.lazy.scss';

const faq = [];

const ALLOWED_BLOCKS = ['wpsp/faq-child'];

const Render = (props) => {
	useLayoutEffect(() => {
		styles.use();
		return () => {
			styles.unuse();
		};
	}, []);
	props = props.parentProps;
	const { attributes } = props;
	const { equalHeight } = attributes;

	const getFaqChildTemplate = (faqCount, faqAarr) => {
		let i = 0;
		const templates = [];
		while (i < faqCount) {
			templates.push(['wpsp/faq-child', faqAarr[i]]);
			i += 1;
		}

		return templates;
	};

	const equalHeightClass = equalHeight ? 'wpsp-faq-equal-height' : '';

	return (
		<div
			className={classnames(
				'wpsp-faq__outer-wrap',
				`wpsp-block-${props.clientId.substr(0, 8)}`,
				`wpsp-faq-icon-${props.attributes.iconAlign}`,
				`wpsp-faq-layout-${props.attributes.layout}`,
				`wpsp-faq-expand-first-${props.attributes.expandFirstItem}`,
				`wpsp-faq-inactive-other-${props.attributes.inactiveOtherItems}`,
				equalHeightClass
			)}
			data-faqtoggle={props.attributes.enableToggle}
		>
			<Suspense fallback={lazyLoader()}>
				<InnerBlocks
					template={getFaqChildTemplate(2, faq)}
					templateLock={false}
					allowedBlocks={ALLOWED_BLOCKS}
					__experimentalMoverDirection={'vertical'}
				/>
			</Suspense>
		</div>
	);
};
export default React.memo(Render);
